import { EIV_ENDPOINT } from '../APIUtils';
import { getAxiosInstance } from '../InitAxios';

export const getEmailStatusByEmail = async (email) => {
  const axiosInstance = getAxiosInstance();
  return axiosInstance.get(EIV_ENDPOINT.CIAM_STATUS_BY_EMAIL(email));
};
